var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'has-logo': _vm.showLogo }},[_c('div',{staticStyle:{"width":"100%","height":"50px","margin-top":"3px","cursor":"pointer"},on:{"click":function($event){return _vm.toDashboard()}}},[_c('img',{staticStyle:{"zoom":"0.82","margin-top":"8px","margin-left":"16px"},attrs:{"src":require("@/icons/logo.png")}})]),_vm._v(" "),_c('el-scrollbar',{attrs:{"wrap-class":"scrollbar-wrapper"}},[_c('el-menu',{attrs:{"default-active":_vm.$route.path,"collapse":_vm.isCollapse,"background-color":_vm.variables.menuBg,"text-color":_vm.variables.menuText,"unique-opened":false,"active-text-color":_vm.variables.menuActiveText,"collapse-transition":false,"default-openeds":[
        '/businessManagement',
        '/appCenter',
        '/SecurityAudit',
        '/hotel',
        '/operation',
        '/system',
        '/systemHotel',
        '/hotelAnalysis',
        '/operationLog',
        '/revenue',
        '/productIntroduction'
      ],"mode":"vertical"}},_vm._l((_vm.routes),function(route){return _c('sidebar-item',{key:route.path,attrs:{"item":route,"base-path":route.path}})}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }